import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const StyledFilterHeading = styled.p`
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[400])};
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
`;

export const FlexRowWrap = styled(FlexRow)`
    flex-wrap: wrap;
`;

export const StyledRatingFilterContainer = styled.div`
    width: 260px;
`;
